//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['delay', 'liveData'],
  computed: {
    logo() {
      return this.$store.state.live.detail.LoadingImage
    },
    screenImage() {
      return this.$store.state.live.detail.FlashScreenImage
    },
    url() {
      if (this.$store.state.live.detail.Id === '20180525hz2') {
        if (this.isIphoneX()) {
          // 返回王俊凯长图
          return 'https://assets.aiyaopai.com/WechatIMG1730.jpeg'
        } else {
          return this.$store.state.live.detail.FlashScreenImage
        }
      } else {
        return this.$store.state.live.detail.FlashScreenImage
      }
    }
  },
  data() {
    return {
      isShow: true,
      times: this.delay / 1000,
      flag: '',
      width: 0,
      height: 0
    }
  },
  mounted() {
    this.width = document.documentElement.clientWidth + 'px'
    this.height = document.documentElement.clientHeight + 'px'
  },

  watch: {
    liveData() {
      if (this.liveData.Id) {
        this.isShow = true
        if (this.screenImage) {
          this.flag = 'customer'
        } else {
          this.flag = 'def'
        }
        this.width = document.documentElement.clientWidth + 'px'
        this.height = document.documentElement.clientHeight + 'px'
        this.calu()
        setTimeout(() => {
          this.hidden()
        }, this.delay)
      }
    }
  },
  methods: {
    calu() {
      setInterval(() => {
        --this.times
      }, 1000)
    },
    show() {
      this.isShow = true
    },
    isIphoneX() {
      return (
        /iphone/gi.test(navigator.userAgent) &&
        (screen.height == 812 && screen.width == 375)
      )
    },
    hidden() {
      this.isShow = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.vue